<template>
  <div class="ma-0 pa-0 mt-n10">
    <v-container>
      <div style="width: 25%;" class="mb-n9">
        <CommonImportFiles @loadCRUDList="loadBillRequestAfterImport" />
      </div>
      <div>
        <CRUDList class="mt-10" :canAdd="true"
          :canEdit="true" :canSave="true" :showSelect="false" :canDeleteInDialog="true"
          :enableFixedHeaders="true" :displayTopPagination="false"
          :headers="headers" :baseCrudKey="baseCrudKey"
          tableWrapperDynamicClassname='elevation-3 ma-3 pt-0 pa-1 taxroll-table-wrapper'
          tableDynamicClassname='taxroll-custom-table' tableDynamicHeight='300'
          :defaultSortBy="defaultSortBy" @loadCRUDList="handleLoadTransaction"
          :loadingData="gridLoading.flag" :loadingText="gridLoading.text"
          dialogDynamicWidth="400" dialogHeaderName="Assessor X-Ref"
          @upsertItem="upsertRecords" @deleteItem="deleteFromDiaglog" >
            <template v-slot:[`editedItem`]="{ }">
              <assessorFireTaxXRefDialog :baseCrudKey="baseCrudKey"/>
            </template>
        </CRUDList>
      </div>
    </v-container>
  </div>
</template>

<script>
import {
  mapActions, mapGetters, mapMutations, mapState,

} from 'vuex';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import { assessorFireTaxXRefHeaders } from '../../../shared/Utils/taxHeaders.utils';
import { commonFuncForFilterMtgCoProc, makeCriteriaStateNullIfEmptyString } from '../../common-utils/CommonTaxFunctionalities';
import assessorFireTaxXRefDialog from './assessorFireTaxXRefDialog.vue';
import { defaultGridLoading, manageGridLoading } from '../../../../util/shared/vue-global';
import CommonImportFiles from '../../../common/import/CommonImportFiles.vue';
import '../../../../assets/style.css';

export default {
  name: 'assessorFireTaxXRef',
  data() {
    return {
      baseCrudKey: 'assessorFireTaxXRef',
      headers: assessorFireTaxXRefHeaders,
      gridLoading: defaultGridLoading(),
    };
  },
  components: {
    CRUDList,
    CommonImportFiles,
    assessorFireTaxXRefDialog,
  },
  created() {
    this.onCreatedOrMounted('Assessor Tulsa Tif File Import');
  },
  mounted() {
    this.onCreatedOrMounted('Assessor Tulsa Tif File Import');
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'items',
    ]),
    ...mapState({
      taxDistrictList: (state) => state.base.crud.items.sharedTaxDistrict,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'fireDistrict',
          direction: 'desc',
        },
      ];
    },
  },
  methods: {
    ...mapMutations('tax/MortgageCoProcessing', [
      'setPipeline',
    ]),
    ...mapActions('tax/newTaxroll', [
      'loadAssessorFireTaxXRefRecords',
      'upsertAssessorFireTaxXRef',
      'deleteAssessorFireTaxXRef',
    ]),
    ...mapMutations('base/crud', ['setCriteria']),
    loadBillRequestAfterImport() {
      this.handleLoadTransaction();
    },
    onCreatedOrMounted(val) {
      const itemData = this.items('transform-mapper-list');
      const { filteredTaxItemData } = commonFuncForFilterMtgCoProc(itemData, 'Assessor File');
      const [filtTaxData] = filteredTaxItemData.filter((ft) => ft.name === val);
      this.setPipeline(filtTaxData || {});
    },
    async upsertRecords(item) {
      const { baseCrudKey } = this;
      // this is to check if the item is empty or not
      const isObjIsEmptyOrNot = Object.keys(item).length > 0;
      if (!isObjIsEmptyOrNot) return;

      const itemValue = { ...item };
      await this.upsertAssessorFireTaxXRef({ item: itemValue, baseCrudKey });
    },
    deleteFromDiaglog(item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        const { baseCrudKey } = this;
        this.deleteAssessorFireTaxXRef({ item, baseCrudKey });
      }
    },
    handleLoadTransaction() {
      manageGridLoading(this, true, 'Searching...');
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      const criteria = { ...returnCriteria };
      delete criteria.taxYear;
      this.loadAssessorFireTaxXRefRecords({
        criteria,
        baseCrudKey: this.baseCrudKey,
      }).finally(() => {
        manageGridLoading(this, false);
      });
    },
  },
};
</script>
